// extracted by mini-css-extract-plugin
module.exports = {"noContentWrapper":"favorites-page_noContentWrapper__iILyZ","title":"favorites-page_title__2tc2O","description":"favorites-page_description__3OtXd"};